import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'

export default function DateSelect({ label, handler }) {
    const [startDate, setStartDate] = useState(new Date())

    const handleChange = date => {
        setStartDate(date)
        handler(date)
    }

    return (
        <>
            <div className="w-full lg:w-3/12 px-4">
                <div className="relative w-full mb-3">
                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">{label}</label>
                    <DatePicker selected={startDate} onChange={handleChange} dateFormat={'dd/MM/yyyy'} />{' '}
                </div>
            </div>
        </>
    )
}
